import React, { useEffect, useRef, useState } from 'react';
import {  Divider, Table, Popconfirm, Card, Tooltip, Switch,Input,Button,Tag,Row, Col, Drawer } from 'antd';
import { Link } from "react-router-dom";

import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import './sale-order-process-types-grid.css';
import {SaleOrderProcessDto} from './../../../../../../shared-models/masters/src/lib/saler_order_process/sale_order_process.dto'

import Highlighter from 'react-highlight-words';
import { ColumnProps } from 'antd/lib/table';
import {SaleOrderService} from '@gtpl/shared-services/masters'

import {SaleOrderProcessTypesForm} from '@gtpl/pages/master/master-components/sale-order-status-types-form'
import {CheckCircleOutlined,CloseCircleOutlined,RightSquareOutlined,EyeOutlined,EditOutlined,SearchOutlined } from '@ant-design/icons';
export interface SaleOrderProcessTypesGridProps {}

export function SaleOrderProcessTypesGrid(
  props: SaleOrderProcessTypesGridProps
) {
  const searchInput = useRef(null);
  const [page, setPage] = React.useState(1);
  const [searchText, setSearchText] = useState(''); 
  const [searchedColumn, setSearchedColumn] = useState('');
  const [selectedsaleOrderProcessData, setSelectedSaleOrderProcessData] = useState<any>(undefined);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [saleOrderProcessData, setSaleOrderProcessData] = useState<SaleOrderProcessDto[]>([]);
  
  
const service = new SaleOrderService;

  const openFormWithData=(viewData: SaleOrderProcessDto)=>{
    setDrawerVisible(true);
    setSelectedSaleOrderProcessData(viewData);
  }
  useEffect(() => {
    getAll();
  }, []);
  const getAll= () => {
  service.getAll().then(res => {
      if (res.status) {
        setSaleOrderProcessData(res.data);
      } else {
        if (res.intlCode) {
          setSaleOrderProcessData([]);
            AlertMessages.getErrorMessage(res.internalMessage);
        } else {
         AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      setSaleOrderProcessData([]);
      AlertMessages.getErrorMessage(err.message);
    })
  }
  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const updateSaleOrder = (saleorderData: SaleOrderProcessDto) => {
      service.update(saleorderData).then(res => { console.log(res);
        if (res.status) {
        AlertMessages.getSuccessMessage('Updated Successfully');
         getAll();
          setDrawerVisible(false);
        } else {
          if (res.intlCode) {
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
      })
     }
  const getColumnSearchProps = (dataIndex:string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={ searchInput }
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
    record[dataIndex]
    ? record[dataIndex]
       .toString()
        .toLowerCase()
        .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {    setTimeout(() => searchInput.current.select());   }
    },
    render: text =>
      text ?(
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) :text
      )
      : null
     
  });
  function handleReset(clearFilters) {
    clearFilters();
    setSearchText('');
  };
  const deleteProfile = (saleData:SaleOrderProcessDto) => {
    saleData.isActive=saleData.isActive?false:true;
    service.activatedeActivate(saleData).then(res => { console.log(res);
      if (res.status) {
        getAll();
        AlertMessages.getSuccessMessage('Success'); 
      } else {
        if (res.intlCode) {
          AlertMessages.getErrorMessage(res.internalMessage);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
        }
      }
    }).catch(err => {
      AlertMessages.getErrorMessage(err.message);
    })
  }

  const closeDrawer=()=>{
    setDrawerVisible(false);
  }
  const onChange=(pagination, filters, sorter, extra)=> {
    console.log('params', pagination, filters, sorter, extra);
  }

  const columnsSkelton: ColumnProps<any>[] = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
       render: (text, object, index) => (page-1) * 10 +(index+1)
    },
    // {
    //   title: 'ProcessTypeID',
    //   dataIndex:'processTypeId',
    // },
    {
      title: 'Process Type',
      dataIndex: 'saleorderprocessTypeName',
      //  responsive: ['lg'],
       sorter: (a, b) => a.saleorderprocessTypeName.length - b.saleorderprocessTypeName.length,
       sortDirections: ['descend', 'ascend'],
        ...getColumnSearchProps('saleorderprocessTypeName')
    },
    {
      title: 'Process Type Code',
      dataIndex: 'saleorderprocessTypeCode',
      // responsive: ['lg'],
       sorter: (a, b) =>  a.saleorderprocessTypeCode.localeCompare(b.saleorderprocessTypeCode),//alphanumeric sorting
       sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('saleorderprocessTypeCode')
    },
    
    {
      title: 'Remarks',
      dataIndex: 'remarks',
      // responsive: ['lg'],
       sorter: (a, b) => a.remarks.length - b.remarks.length,
       sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('remarks')
    },
   
    {
      title: 'Status',
      dataIndex: 'isActive',
       render: (isActive, rowData) => (
        <>
          {isActive?<Tag icon={<CheckCircleOutlined />} color="#87d068">Active</Tag>:<Tag icon={<CloseCircleOutlined />} color="#f50">In Active</Tag>}
        </>
      ),
      filters: [
        {
          text: 'Active',
          value: true,
        },
        {
          text: 'InActive',
          value: false,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => 
      {
        // === is not work
        return record.isActive === value;
      },
      
    },
    {
      title:`Action`,
      dataIndex: 'action',
      render: (text, rowData) => (
        <span>         
            <EditOutlined  className={'editSamplTypeIcon'}  type="edit" 
              onClick={() => {
                if (rowData.isActive) {
                   openFormWithData(rowData);
                } else {
                   AlertMessages.getErrorMessage('You Cannot Edit Deactivated Sale Order Process Type');
                }
              }}
              style={{ color: '#1890ff', fontSize: '14px' }}
            />
          
          <Divider type="vertical" />
              <Popconfirm onConfirm={e =>{deleteProfile(rowData);}}
            title={
              rowData.isActive
                ? 'Are you sure to Deactivate saleorderprocessType ?'
                :  'Are you sure to Activate saleorderprocessType ?'
            }
          >  
             <Switch  size="default"
                className={ rowData.isActive ? 'toggle-activated' : 'toggle-deactivated' }
                checkedChildren={<RightSquareOutlined type="check" />}
                unCheckedChildren={<RightSquareOutlined type="close" />}
                checked={rowData.isActive}
              />
            
          </Popconfirm>  
        </span>
      )
    }
  ];


  return (
    <Card title={<span style={{color:'white'}}>Sale Order Process Types</span>}
    style={{textAlign:'center'}} headStyle={{backgroundColor: '#69c0ff', border: 0 }}  extra={<Link to='/saleorderprocesstypes-form' ><span style={{color:'white'}} ><Button className='panel_button' >Create </Button> </span></Link>}   >
     <br></br>
     <Row gutter={40}>
      <Col>
          <Card title={'Total Processes: ' + saleOrderProcessData.length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#bfbfbf'}}></Card>
          </Col>
          <Col>
           <Card title={'Active: ' + saleOrderProcessData.filter(el => el.isActive).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#52c41a'}}></Card>
          </Col>
          <Col>
           <Card title={'In-Active :' + saleOrderProcessData.filter(el => el.isActive == false).length} style={{textAlign: 'left', width: 200, height: 41,backgroundColor:'#f5222d'}}></Card>
          </Col>
          </Row>
          <br></br>
          <Table
          rowKey={record => record.productId}
          columns={columnsSkelton}
          dataSource={saleOrderProcessData}
          pagination={{
            onChange(current) {
              setPage(current);
            }
          }}
          onChange={onChange}
          bordered />
        <Drawer bodyStyle={{ paddingBottom: 80 }} title='Update' width={window.innerWidth > 768 ? '50%' : '85%'}
            onClose={closeDrawer} visible={drawerVisible} closable={true}>
            <Card headStyle={{ textAlign: 'center', fontWeight: 500, fontSize: 16 }} size='small'>
              <SaleOrderProcessTypesForm key={Date.now()}
                updateDetails={updateSaleOrder}
                isUpdate={true}
                saleorderData={selectedsaleOrderProcessData}
                closeForm={closeDrawer} />
            </Card>
          </Drawer>
     </Card>
  );
}

export default SaleOrderProcessTypesGrid;
